import { destinationActionHandlers } from "./destination";

const combineHandlers = (...handlers) =>
  handlers.reduce((accum, handler) => ({ ...accum, ...handler }), {});

// Example analytics handler
// Add an analytics handler, if we want to add additional data (e.g. from Redux) to event.
// const exampleAnalyticsHandlers = {
//   [RegistrationEvents.CLIENT_REG_FORM_OPENED]: (reduxState, trackParams) => {
//     return trackParams;
//   },
// };

export const combinedAnalyticsHandlers = combineHandlers();

// Example action handler.
// Add an action handler for actions we want to track.
// const exampleActionHandlers: ActionHandlers = {
//   ACTION_WE_WANT_TO_TRACK: (reduxState, payload) => {
//     return ["event_name", {}, "all"];
//   },
// };

export const combinedActionHandlers = combineHandlers(
  destinationActionHandlers
);
